import { render } from "./Champ_Select_Document.vue?vue&type=template&id=90dd70fe"
import script from "./Champ_Select_Document.vue?vue&type=script&lang=js"
export * from "./Champ_Select_Document.vue?vue&type=script&lang=js"

import "./Champ_Select_Document.vue?vue&type=style&index=0&id=90dd70fe&lang=scss"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__